<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
<!--        <preLoader v-if="loader"></preLoader>-->
        <div class="container">
            <div class="form-group" style="margin-top: 30px">
                <router-link :to="{path: '/service/create'}" class="btn btn-success">{{ $t('Add') }}</router-link>
<!--                <router-link :to="{path: '/serviceCategories'}" class="btn btn-info"> <span> {{ $t('Assortment management') }}</span>-->
<!--                </router-link>-->


                <button type="button" class="btn btn-default" style="float: left"
                        v-on:click="tableToExcel('testTable', 'W3C Example Table')" >{{ $t('Excel Output Service List') }}</button>


                <button  type="button" class="btn btn-info" data-toggle="modal" style="float: left;margin-left: 10px"
                         data-target="#importExcel">
                    Import Excel</button>
            </div>

            <div class="panel panel-default ">
                <div class="panel-heading">{{ $t('list') }}
                    <input type="text" v-model="search" @keyup="changeUpDown()" class="form-control input-search"
                        :placeholder="$t('Search')">
                    <select class="select-search" v-model="length" @change="changeUpDown()">
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table  id="testTable" class="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th class="position">

                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`code`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else @click="changeUpDown(`code`,`asc`)"
                                            class="fa icon-form">&#xf103;</i>
                                        <small>کد رابط مالی</small>
                                    </th>
                                    <th class="position">

                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`service_category`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else @click="changeUpDown(`service_category`,`asc`)"
                                            class="fa icon-form">&#xf103;</i>
                                      {{ $t('Assortment') }}
                                    </th>
                                    <th class="position">

                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`title`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else @click="changeUpDown(`title`,`asc`)"
                                            class="fa icon-form">&#xf103;</i>
                                        {{ $t('Title') }}</th>
                                    <th class="position">

                                        <!-- <i v-if="orderIcon==`desc`" @click="changeUpDown(`first_name`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else @click="changeUpDown(`first_name`,`asc`)"
                                            class="fa icon-form">&#xf103;</i> -->
                                       {{ $t('Image') }} </th>
                                    <th class="position">

                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`price`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else @click="changeUpDown(`price`,`asc`)"
                                            class="fa icon-form">&#xf103;</i>
                                         {{ $t('Default price') }}({{$curency}})</th>
<!--                                    <th class="position">-->

<!--                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`min_time`,`desc`)"-->
<!--                                            class="fa  icon-form">&#xf102;</i>-->
<!--                                        <i v-else @click="changeUpDown(`min_time`,`asc`)"-->
<!--                                            class="fa icon-form">&#xf103;</i>-->
<!--                                        {{ $t('Minimum time') }}({{ $t('min') }})-->
<!--                                        </th>-->
<!--                                    <th class="position">-->

<!--                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`max_time`,`desc`)"-->
<!--                                            class="fa  icon-form">&#xf102;</i>-->
<!--                                        <i v-else @click="changeUpDown(`max_time`,`asc`)"-->
<!--                                            class="fa icon-form">&#xf103;</i>-->
<!--                                        {{ $t('Maximum time') }}({{ $t('min') }})-->
<!--                                        </th>-->
<!--                                    <th class="position">-->

<!--                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`score`,`desc`)"-->
<!--                                            class="fa  icon-form">&#xf102;</i>-->
<!--                                        <i v-else @click="changeUpDown(`score`,`asc`)"-->
<!--                                            class="fa icon-form">&#xf103;</i>-->
<!--                                        {{ $t('Score') }} </th>-->

                                    <th width="100">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr id="items" v-for="(item, index) in items" :key="index">
                                    <td>
                                        {{ item.code }}
                                    </td>
                                    <td>
                                        <span v-if="item.service_category">{{ item.service_category.title }}</span>

                                    </td>
                                    <td>{{ item.title }}</td>
                                    <td class="text-center">
                                        <img v-if="item.image && item.image != 'null'" class="img" :src="item.image" >
                                        <i v-else style="font-size: 23px;" class="fa fa-user-circle color-red"></i>

                                    </td>
                                    <td>{{ spliceNumber(item.price)  }}</td>
<!--                                    <td>{{ item.min_time }}</td>-->
<!--                                    <td>{{ item.max_time }}</td>-->
<!--                                    <td>-->
<!--                                        <span class="badge badge-secondary">{{ item.score }}</span>-->
<!--                                    </td>-->


                                    <td>
                                        <router-link :to="{path: '/service/edit/'+item.id, params: {id: item.id}}"
                                            class="btn btn-xs btn-default">
                                            {{ $t('Edit') }}
                                        </router-link>
                                        <a href="javascript: void(0)" class="btn btn-xs btn-danger"
                                            v-on:click="deleteEntry(item.id, index)">
                                            {{ $t('Delete') }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


            </div>
            <div class="col-xs-12 text-center">
                <pagination api="/api/services" @pagnationChangeDate='pagnation'></pagination>
            </div>
        </div>






        <!-- Modal -->
        <div id="importExcel" class="modal fade " role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">


                    <form v-on:submit.prevent="getAttaches()">

                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                            <h4 class="modal-title"> Import Excel</h4>
                        </div>
                        <div class="modal-body">

                            <div class="row">
                                <div class="col-xs-12 form-group">
                                    <label class="control-label">Excel </label>
                                    <div class="form-group">
                                        <div class="input-group input-file" name="Fichier1">
                                            <input type="text" class="form-control" :placeholder="placeholder" />
                                            <input type="file" class="filestyle" ref="file" @change="onFileChangeNote($event)" />
                                            <span class="input-group-btn">
                                            <!--<button class="btn btn-default btn-choose" type="button">فایل</button>-->
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default"
                                    data-dismiss="modal"> {{ $t('Close') }}</button>
                            <button class="btn btn-primary" data-dismiss="modal" @click="importExcel"> {{ $t('done') }} </button>
                        </div>


                    </form>

                </div>

            </div>
        </div>






    </div>
</template>

<script>
    // const auth = {
    //     headers: {
    //         Authorization: 'bearer ' + localStorage.getItem('token')
    //     }
    // };

    export default {

        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                items: [],
                loader: false,
                               search:"",
                length:"",
                orderIcon:"",




                excel:{
                    file: '',

                },
                placeholder: '  انتخاب کنید',



            }
        },


        mounted() {
            this.loader = true
            axios
                .get('/api/services', this.auth)
                .then(response => {
                    this.items = response.data.data;
                    console.log(this.items);
                    this.loader = false

                })
                .catch(error => {
                    this.loader = false
                    if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                        this.$snotify.warning('دسترسی شما برای این بخش محدود شده است');
                    } else {
                        this.$snotify.warning(error.response.data.message);
                    }

                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
        }


        ,
        methods: {
  changeUpDown(column,orderBY){
                 let app=this
                 app.loader = true
                 let col=column
                 let orderMod=orderBY
                 if(column == undefined || column ==null ){
                     col=""
                 }
                 if(orderBY ==undefined || orderBY ==null ){
                     orderMod="asc"
                     
                 }
                 if(orderBY=="asc"){
                     app.orderIcon="desc"
                     
                 }else{
                      app.orderIcon="asc"
                 }
                 console.log( app.orderIcon)
                setTimeout(function(){
                 axios
                .get(`/api/services?search=${app.search}&column=${col}&length=${app.length}&order=${orderMod}`, app.auth)
                .then(response => {
                    app.items = response.data.data;
                     app.loader = false
                    console.log(app.items);

                })
                .catch(error => {
                    console.log(error);
                    app.loader = false
                    app.errored = true
                })
                .finally(() => app.loading = false)
                },1000)
            },
            pagnation(api) {
                axios
                    .get(api, this.auth)
                    .then(response => {
                        this.items = response.data.data;

                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                $("input[data-type='number']").keyup(function (event) {
                    var $this = $(this);
                    var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                    $this.val(num2);
                });
                if (number != null)
                    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")

                },
            deleteEntry(id, index) {
                if (confirm("از حذف آیتم مطمئن هستید؟")) {
                    var app = this;
                    axios.delete('/api/services/' + id, app.auth)
                        .then(function (resp) {
                            app.items.splice(index, 1);
                        })
                        .catch(function (resp) {
                            alert("امکان حذف آیتم وجود ندارد");
                        });
                }
            },


            getRelation(id) {
                axios.get('/api/services/' + id, this.auth)
                    .then(function (resp) {
                        // console.log(resp.data.data.id);
                        return resp.data.data.id;
                    })
                    .catch(function (resp) {
                        return 'نا مشخص';
                    });
            },


            tableToExcel (table, name) {

                var uri = 'data:application/vnd.ms-excel;base64,'
                    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }


                if (!table.nodeType) table = document.getElementById(table)
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
                window.location.href = uri + base64(format(template, ctx))

            },




            onFileChangeNote(e) {
                this.excel.file = this.$refs.file.files[0];
                this.placeholder = this.$refs.file.files[0].name
                console.log(this.excel ,"note ch 144")
            },


            importExcel() {
                var app = this;
                var newItem = app.excel;

                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                        console.log(key, element);
                    }
                }

                axios
                    .post(`/api/serviceAdd/importExcel`,formData, app.auth)
                    //                axios.post('/api/services', formData, app.auth)
                    .then(function (resp) {
                        app.$snotify.success(app.$t('Item saved successfully'));

                    })
                    .catch(function (e) {
                        console.log(e.response.data);

                        for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value, {
                                timeout: 7000,
                                closeOnClick: true,
                                pauseOnHover: true
                            });
                        }
                    });





            },







        }
    }

</script>
<style>
    .color-red {
        color: red
    }

    .color-green {
        color: greenyellow
    }

    .img {
        width: 32px;
    }

</style>
<!--<script>-->
<!--export default {-->
<!--computed: {-->
<!--username() {-->
<!--// We will see what `params` is shortly-->
<!--return this.$route.params.username-->
<!--}-->
<!--},-->
<!--methods: {-->
<!--goBack() {-->
<!--window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->
